import PropTypes from 'prop-types';
import React from 'react';

import Heading from '@bibliocommons/heading';

import Tabs from 'app/components/shared/Tabs';
import { tabsOptionShape } from 'app/components/shared/Tabs/shapes'; // TODO: move this into app/shapes

import './AdminBrowseCategoriesPage.scss';

const AdminBrowseCategoriesPage = ({ onTabSelected, tabOptions, topLevelCategoryId }) => {
  return (
    <div className="cp-admin-browse-categories-page container">
      <Heading size="large" tagName="h1" variant>
        Browse Categories
      </Heading>

      <Tabs
        ariaLabel="TODO: Choose top-level category"
        initialSelectedOptionId={topLevelCategoryId}
        key={topLevelCategoryId}
        onTabSelected={onTabSelected}
        options={tabOptions}
      />
    </div>
  );
};

AdminBrowseCategoriesPage.propTypes = {
  onTabSelected: PropTypes.func.isRequired,
  tabOptions: PropTypes.arrayOf(tabsOptionShape).isRequired,
  topLevelCategoryId: PropTypes.string.isRequired
};

export default AdminBrowseCategoriesPage;
